const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const getAllCustomerList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ALL_CUSTOMER_LIST_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_ALL_CUSTOMER_LIST_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default getAllCustomerList;